export default __webpack_public_path__ + "static/media/report.fef57b86.svg";